import { CardD } from './card-d';
import { CardF } from './card-f';
import { CardMI } from './card-mi';
import { CardOA } from './card-oa';
import { CardS } from './card-s';

export type CommonCard =
  CardOA |
  CardS |
  CardMI |
  CardD |
  CardF;

export const cardsOptions = [
  { value: 'oa', label: 'Oggetto artistico' },
  { value: 'f', label: 'Fotografia' },
  { value: 'mi', label: 'Matrice incisa' },
  { value: 'd', label: 'Disegno' },
  { value: 's', label: 'Stampa' },
];
